export default __webpack_public_path__ + "static/media/standard.cf74010e.jpg";